// src/pages/AddExtension.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { useNavigate } from "react-router-dom";
import { api } from "../components/Api";
import Loading from "../components/Loading";

export default function AddExtension() {
    const navigate = useNavigate();
    const [licenses, setLicenses] = useState([]);
    const [collections, setCollections] = useState([]);
    const [selectedLicense, setSelectedLicense] = useState("");
    const [selectedCollection, setSelectedCollection] = useState("");
    const [form, setForm] = useState({ extension_name: "" });
    const [loading, setLoading] = useState(true);
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    const filteredCollections = collections.filter(
        (c) => c.license_card_id === parseInt(selectedLicense)
    );

    // Charger les licences
    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await api.get("/license-cards");
                setLicenses(res.data);
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des licences.");
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Charger les collections selon la licence sélectionnée
    useEffect(() => {
        if (!selectedLicense) {
            setCollections([]);
            setSelectedCollection("");
            return;
        }
        const fetchCollections = async () => {
            try {
                const res = await api.get(`/collections?license_card_id=${selectedLicense}`);
                setCollections(res.data);
                setSelectedCollection(""); // reset collection
            } catch (err) {
                console.error(err);
                alert("Erreur lors de la récupération des collections.");
            }
        };
        fetchCollections();
    }, [selectedLicense]);

    const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedLicense) return alert("Veuillez sélectionner une licence.");
        if (!selectedCollection) return alert("Veuillez sélectionner une collection.");
        if (!form.extension_name.trim()) return alert("Le nom de l'extension est obligatoire.");

        try {
            const payload = {
                extension_name: form.extension_name.trim(),
                collection_id: parseInt(selectedCollection),
            };
            await api.post("/extensions", payload);
            alert("Extension ajoutée avec succès !");
            navigate("/extension-list");
        } catch (err) {
            console.error(err);
            if (err.response?.status === 422) {
                alert("Cette extension existe déjà dans cette collection.");
            } else {
                alert("Erreur lors de l'ajout de l'extension.");
            }
        }
    };

    const token = localStorage.getItem("token");
    if (!token || localStorage.getItem("role") > 2) navigate("/");

    if (loading) return <Loading message="Chargement..." />;

    return (
        <div className="container mx-auto p-6 max-w-md">
            <h1 className="text-2xl font-bold mb-4">Ajouter une Extension</h1>
            <form onSubmit={handleSubmit} className="space-y-4">

                {/* Licence */}
                <div>
                    <label htmlFor="license" className="block font-medium mb-1">Licence :</label>
                    <select
                        id="license"
                        value={selectedLicense}
                        onChange={(e) => setSelectedLicense(e.target.value)}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    >
                        <option value="">-- Sélectionnez une licence --</option>
                        {licenses.map(l => (
                            <option key={l.id} value={l.id}>{l.license_card}</option>
                        ))}
                    </select>
                </div>

                {/* Collection */}
                <div>
                    <label htmlFor="collection" className="block font-medium mb-1">Collection :</label>
                    <select
                        value={selectedCollection}
                        onChange={e => setSelectedCollection(e.target.value)}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                    >
                        <option value="">-- Sélectionnez une collection --</option>
                        {filteredCollections.map(c => (
                            <option key={c.id} value={c.id}>{c.collection_name}</option>
                        ))}
                    </select>
                </div>

                {/* Nom de l'extension */}
                <div>
                    <label htmlFor="extension_name" className="block font-medium mb-1">Nom de l'extension :</label>
                    <input
                        type="text"
                        id="extension_name"
                        name="extension_name"
                        value={form.extension_name}
                        onChange={handleChange}
                        className="w-full border p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 dark:bg-gray-700 bg-white"
                        required
                    />
                </div>

                <button
                    type="submit"
                    className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded"
                >
                    Ajouter
                </button>
            </form>
        </div>
    );
}
